import { render, staticRenderFns } from "./ValidarMapeoColumnaModal.vue?vue&type=template&id=15fd25cc&scoped=true&"
import script from "./ValidarMapeoColumnaModal.vue?vue&type=script&lang=ts&"
export * from "./ValidarMapeoColumnaModal.vue?vue&type=script&lang=ts&"
import style0 from "./ValidarMapeoColumnaModal.vue?vue&type=style&index=0&id=15fd25cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15fd25cc",
  null
  
)

export default component.exports